//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/UserDefinedObjects.js";
import "../no/TransientObject.js";
import "../no/NXColor.js";
let d=[[[0,"ColorAlphaValue",0,0],[0,"ColorModeType",0,0],[0,"ColorValue",0,0],[0,"RenderingPassType",0,0],[0,"ViewContext",0,"UserDefinedObjects.UserDefinedObjectGraphicsViewContext",0],[0,"WindowContext",0,"UserDefinedObjects.UserDefinedObjectGraphicsWindowContext",0]],[[[],"Dispose",{},0,0]],[]];
SPLM.UserDefinedObjects.UserDefinedObjectGraphicsContext = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.UserDefinedObjects.UserDefinedObjectGraphicsContext";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.UserDefinedObjects.UserDefinedObjectGraphicsContext.ColorMode = Object.freeze({
    "Regular" : "Regular", "Highlight" : "Highlight", "SuperHighlight" : "SuperHighlight"});

SPLM.UserDefinedObjects.UserDefinedObjectGraphicsContext.RenderingPass = Object.freeze({
    "Opaque" : "Opaque", "BackFacingTranslucency" : "BackFacingTranslucency", "FrontFacingTranslucency" : "FrontFacingTranslucency", "DepthBufferTranslucency" : "DepthBufferTranslucency", "StencilBufferCapping" : "StencilBufferCapping"});

export default SPLM;